import * as yup from 'yup';

export const TerminalSchema = yup.object().shape({
  name: yup.string().trim().required('拠点名を入力してください').nullable(),
});
